export const sum = (arr: number[]): number => arr.reduce((acc, n) => acc + n, 0);